export function cleanSupplierConfirmation(confirmation) {
    if (!confirmation) {
        return confirmation;
    }

    return confirmation
        .replaceAll(' -cl', '')
        .replaceAll(' -ar', '')
        .replaceAll(' -rc', '');
}
